import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { V4ScheduleCard } from './v4_schedule_card';
import { V4SchedulesDropdown } from './v4_schedules_dropdown';
import { AvailabilitySidePanel, AvailabilitySidePanelProvider } from '../available_hours/components/availability_side_panel';
const sectionHeaderRowCss = "s1jefcwf";
const availableHoursSectionCss = "agmu1oz";
const scheduleSelectorCss = "s5brhle";
export const V4AvailableHours = ({
  formPath,
  isLocked = false,
  isReadOnly = false,
  onViewCalendarInPreview,
  isCalendarPreviewActive = false,
  onClearCalendarPreview
}) => {
  const isReadOnlyState = isLocked || isReadOnly;
  const [{
    value: {
      usingCustomHours
    }
  }] = useFormField({
    name: formPath
  });
  const readOnlyScheduleLabel = usingCustomHours ? I18n.t('publisher.event_type_editor.sections.available_hours.custom_hours_label') : I18n.t('publisher.event_type_editor_crud.availability.default_hours_label');
  return <AvailabilitySidePanelProvider>
      <div className={availableHoursSectionCss} data-testid="v4-available-hours">
        <div className={sectionHeaderRowCss}>
          <TitleText level={3} size="medium">
            {I18n.t('publisher.event_type_editor.sections.available_hours.title')}
          </TitleText>
          <div className={scheduleSelectorCss}>
            {isReadOnlyState ? <BodyText size="medium">{readOnlyScheduleLabel}</BodyText> : <V4SchedulesDropdown formPath={formPath} />}
          </div>
        </div>
        <V4ScheduleCard formPath={formPath} isLocked={isLocked} isReadOnly={isReadOnly} onViewCalendarInPreview={onViewCalendarInPreview} isCalendarPreviewActive={isCalendarPreviewActive} onClearCalendarPreview={onClearCalendarPreview} />
        {usingCustomHours && <BodyText color="muted" size="small">
            {I18n.t('publisher.event_type_editor_crud.availability.custom_hours_footer')}
          </BodyText>}
      </div>
      <AvailabilitySidePanel />
    </AvailabilitySidePanelProvider>;
};

require("./v4_available_hours.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./v4_available_hours.js");